import { Outlet } from 'application/core/domain/entity/outlet/Outlet'
import { setOutlet } from 'application/core/domain/store/userReducer'
import { useOutlets } from 'application/core/domain/useCase/outlets/getOutlets'
import React, { useCallback, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { RootState } from 'application/core/domain/store/reduxStore'
import { Loader, OutletItem } from 'application/presentation/common/uiComponents'
import _cloneDeep from 'lodash/cloneDeep'
import _sort from 'lodash/sortBy'
import { getGeolocationDistance, useCurrentPosition } from 'application/utils/geolocationUtils'
import Header from 'application/presentation/common/Header/Header'
import { setBasket } from 'application/core/domain/store/basketReducer'

import s from './OutletsListPage.module.scss'

const OutletsListPage = () => {
  const { outlet, region } = useSelector(({ userReducer }: RootState) => ({
    outlet: userReducer.outlet,
    region: userReducer.region,
  }))
  const { data, isLoading } = useOutlets()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const currentPosition = useCurrentPosition()

  const selectBar = useCallback(
    (item: Outlet) => {
      sessionStorage.setItem('outlet_id', item.id.toString())
      setBasket([])(dispatch)
      setOutlet(item)(dispatch)
      navigate('/booking')
    },
    [dispatch, navigate],
  )

  const barList = useMemo(() => {
    if (data && data.length) {
      let filtered = _cloneDeep(data)
      // if (region) {
      //   filtered = _filter(data, (item: Outlet) => item.region_id === region.id)
      // }
      let outlets = _sort(
        filtered.map((item: any) => ({
          ...item,
          // is_not_workink: barIsNotWorking(item),
          distance: currentPosition
            ? getGeolocationDistance(
                item.height,
                item.width,
                currentPosition.longitude,
                currentPosition.latitude,
              )
            : null,
        })),
        (item) => {
          return item.is_distance_order ? item.distance || 1 : item.distance + 50
        },
      )
      return outlets
    }
    return []
  }, [data, currentPosition])

  return (
    <>
      <Header title="Каталог моек" />
      <div className={s.container}>
        {isLoading ? (
          <Loader size={32} />
        ) : (
          <div className={s.outlets}>
            {barList.map((item: Outlet) => (
              <OutletItem data={item} onClick={selectBar} key={`outlet_item_${item.id}`} />
            ))}
          </div>
        )}
      </div>
    </>
  )
}

export default React.memo(OutletsListPage)
